import { Theme } from '@mui/material';
import { statusTransaction } from './status';

export const getLinkTransaction = (networkChain: string) => {
    let link = '';
    switch (networkChain) {
        case '3':
            link = 'https://ropsten.etherscan.io/tx/';
            break;

        case '97':
            link = 'https://testnet.bscscan.com/tx/';
            break;

        case 'TRX-3':
            link = 'https://shasta.tronscan.org/#/transaction/';
            break;
    }
    return link;
};

export const getColorStatus = (status: string, theme: Theme) => {
    let color = '';
    switch (status) {
        case statusTransaction.SUCCESS:
            color = theme.palette.success.main;
            break;
        case statusTransaction.FAILED:
            color = theme.palette.error.main;
            break;
        case statusTransaction.PENDING:
            color = theme.palette.warning.dark;
            break;
    }
    return color;
};

export const getColorActiveStatus = (isActive: number | undefined, theme: Theme) => {
    let color = '';
    if (isActive === 1) color = theme.palette.success.main;
    else color = theme.palette.error.main;
    return color;
};
